import apiClient from '../utils/apiClient';

const guardianPlacementService = {
  // Get initial data for step 1
  async getStep1Data(propertyId, guardianId) {
    try {
      const response = await apiClient.get(`/api/guardian-placement/step1/${propertyId}/${guardianId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching step 1 data:', error);
      throw error;
    }
  },

  // Get available guardians for shared placement
  async getAvailableGuardians(propertyId, guardianId, roomId) {
    try {
      const response = await apiClient.get(`/api/guardian-placement/step1b/${propertyId}/${guardianId}/${roomId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching available guardians:', error);
      throw error;
    }
  },

  // Get data for step 2 (direct access)
  async getStep2Data(propertyId, guardianId, roomId) {
    try {
      const response = await apiClient.get(`/api/guardian-placement/step2/${propertyId}/${guardianId}/${roomId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching step 2 data:', error);
      throw error;
    }
  },

  // Generate payment links and QR codes
  async generatePaymentLinks(propertyId, guardianId, roomId, data) {
    try {
      const response = await apiClient.post(`/api/guardian-placement/step2/${propertyId}/${guardianId}/${roomId}`, data);
      return response.data;
    } catch (error) {
      console.error('Error generating payment links:', error);
      throw error;
    }
  },

  // Complete the placement process
  async completePlacement(propertyId, guardianId, roomId, data) {
    try {
      const response = await apiClient.post(`/api/guardian-placement/step3/${propertyId}/${guardianId}/${roomId}`, data);
      return response.data;
    } catch (error) {
      console.error('Error completing placement:', error);
      throw error;
    }
  },

  // Check placement status using token
  async getPlacementStatus(token) {
    try {
      const response = await apiClient.get(`/api/guardian-placement/status/${token}`);
      return response.data;
    } catch (error) {
      console.error('Error checking placement status:', error);
      throw error;
    }
  },

  // Get guardian placement dashboard data
  async getDashboardData() {
    try {
      const response = await apiClient.get('/api/guardian-placement/');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }
};

export default guardianPlacementService;